import log from 'salvo-lite/log'

class Header {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        let breakpoint = 10

        window.addEventListener('scroll', function () {
            const distanceFromTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && (document.documentElement.scrollTop || 0))
            if (distanceFromTop > breakpoint) {
                document.body.classList.add('hide-countdown')
            } else {
                document.body.classList.remove('hide-countdown')
            }
        })
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Header.js